<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleLotti > 0"
      item-key="_id"
      :headers="headers"
      :items="lotti"
      :options.sync="options"
      :server-items-length="totaleLotti"
      :loading="loading"
      class="elevation-1"
      @item-expanded="itemExpanded"
      :disable-sort="true"
      :footer-props="{
        itemsPerPageOptions: [10, 15, 50, 100]
      }"
      :items-per-page="15"
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      :show-expand="true"
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>{{ title || 'Gestione Lotti' }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class="mb-2 mr-5" @click="onAcquisto">Acquisto</v-btn>
        <v-btn color="info" dark class="mb-2 mr-5" @click="onAssemblaggio">Assemblaggio</v-btn>
        <v-btn color="green lighten-1" dark class="mb-2 mr-5" @click="onSezionamento">Sezionamento</v-btn>
        <v-btn color="green darken-2" dark class="mb-2 mr-5" @click="onProduzione">Produzione</v-btn>
        <dialog-errore :show="dialogErrore" :title="errorTitle" :message="errorMessage" @dialogConfirm="dialogErrore = false"/>
        <dialog-stampa
          :show="dialogStampa"
          title="Stampa Etichette"
          confirmText="Stampa"
          cancelText="Annulla"
          :totaleEtichette="totaleEtichette"
          :isStampaEtichette="true"
          :isModuloA4="isModuloA4"
          @dialog-print="onDialogPrint"
          @dialog-cancel="onDialogCancel"
        />
      </v-toolbar>
      <filtri :filtraTipiLotto="filtroTipiLotto" @ricerca="onRicerca"/>
    </template>
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | dateTime }}
    </template>
    <template v-slot:[`item.dataScadenza`]="{ item }">
      {{ item.custom && item.custom.scadenza | dateNull }}
    </template>    
    
    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item, false)" title="Modifica il lotto">mdi-pencil</v-icon>
<!--       <v-icon small class="mr-2" @click="editItem(item, true)" title="Dettaglio del lotto">mdi-archive-eye-outline</v-icon> -->
      <v-icon small class="mr-2" @click="stampaLotto(item)" title="Stampa Lotto">mdi-printer-outline</v-icon>
    </template>
    <template v-slot:no-data>
      Nessun dato disponibile
    </template>
    </v-data-table>
    <!-- <speed-dial @comando="onSpeedDialogComando"/> -->
    <lotto-acquisto :showDialog="showLottoAcquisto" :idDocumento="idDocumento" :filtraTipiLotto="filtraTipiLotto" :readOnly="readOnly" :trigger="triggerUpdate" @refresh="getDataFromApi"/>
    <lotto-assemblaggio :showDialog="showLottoAssemblaggio" :idDocumento="idDocumento" :filtraTipiLotto="filtraTipiLotto" :readOnly="readOnly" :trigger="triggerUpdate" @refresh="getDataFromApi"/>
    <lotto-sezionamento :showDialog="showLottoSezionamento" :idDocumento="idDocumento" :filtraTipiLotto="filtraTipiLotto" :readOnly="readOnly" :trigger="triggerUpdate" @refresh="getDataFromApi"/>
    <lotto-produzione :showDialog="showLottoProduzione" :idDocumento="idDocumento" :filtraTipiLotto="filtraTipiLotto" :readOnly="readOnly" :trigger="triggerUpdate" @refresh="getDataFromApi"/>
  </div>
</template>

<script>
  import { dynamicSortMultiple, getAnnoRiferimento, capitalizeFirstLetter } from '@/components/helpers.js'
  import DialogErrore from '@/components/dialogErrore'
  import DialogStampa from '@/components/dialogStampa'
  // import SpeedDial from './speedDial.vue'
  import Filtri from './testate_filtri'
  import LottoAcquisto from './edit/acquisto'
  import LottoAssemblaggio from './edit/assemblaggio'
  import LottoSezionamento from './edit/sezionamento'
  import LottoProduzione from './edit/produzione'
  import configurazioni from '@/services/configurazioniService.js'
  import moment from 'moment'
  import documenti from '@/services/documentiService.js'
  import etichetteService from '@/services/etichetteService.js'
  import reporting from '@/services/reportingService.js'
  const labelsPath = window.appConfig.VUE_APP_MOL_S_LABELS

  export default {
    components: {
      DialogErrore,
      Filtri,
      // SpeedDial,
      DialogStampa,
      LottoAcquisto,
      LottoAssemblaggio,
      LottoProduzione,
      LottoSezionamento
      // Recapiti
    },
    props: {
      filtraTipiLotto: Array,
      title: String
    },
    data () {
      return {
        totaleLotti: 0,
        lotti: [],
        selected: [],
        loading: true,
        options: {},
        headers: [
          { text: 'Tipo', value: 'tipoDocumento.descrizione', align: 'start'},
          { text: 'Numero', value: '_id'},
          { text: 'Data', value: 'data' },
          { text: 'Scadenza', value: 'dataScadenza' },
          { text: 'Info', value: 'custom.info' },
          { text: 'Riferimento', value: 'custom.riferimento' },
          { text: 'Stato', value: 'stato.descrizione' },
          { text: 'Actions', value: 'actions', sortable: false },
          { text: '', value: 'data-table-expand' }
        ],
        expanded: [],
        singleExpand: false,
        dialogErrore: false,
        dialogDelete: false,
        dialogStampa: false,
        editedIndex: -1,
        editedItem: null,
        defaultItem: null,
        filtri: null,
        tab: null,
        pathEtichettePrefix: '',
        usaQtaAnagrafica: false,
        // salta: 0,
        tipoStampa: '',
        report: '',
        isModuloA4: false,
        errorTitle: 'Errore aggiornamento Lotto',
        errorMessage: '',
        showDialogMultiple: false,
        showDettaglioFattura: false,
        triggerUpdate: 1,
        triggerDettaglio: 1,
        idDocumento: null,
        showLottoAcquisto: false,
        showLottoAssemblaggio: false,
        showLottoProduzione: false,
        showLottoSezionamento: false,
        readOnly: false,
        lottoCollegato: {}
      }
    },
    async created() {
      this.pathEtichettePrefix = window.appConfig.VUE_APP_MOL_API_GATEWAY || ''
      await this.getDefaultItem()
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuovo Lotto' : 'Modifica Lotto'
      },
      lottiSaved() {
        return this.$store.getters['lotti/saved']
      },
      testataAperta() {
        return this.$store.getters['lotti/page'] === 'testata'
      },
      refreshList() {
        // console.log('refreshList')
        return this.$store.getters['lotti/refreshTestata']
      },
      lottiSorted() {
        const els = this.lotti
        const elSorted = els.sort(dynamicSortMultiple('_id'))
        return elSorted
      },
      totaleEtichette() {
        const elSel = this.selected
        if (elSel.length > 0) {
          const totaleAnagrafica = _.sum(elSel.map(x => x.qtaAnagrafica))
          const totaleLotti = _.sum(elSel.map(x => x.qtaLotti))
          return { totaleAnagrafica, totaleLotti }
        } else {
          return { totaleAnagrafica: 0, totaleLotti: 0 }
        }
      },
      filtroTipiLotto() {
        return this.filtraTipiLotto && this.filtraTipiLotto.length > 0 ? this.filtraTipiLotto.map(x => x.tipoLotto) : []
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
      async lottiSaved(value) {
        if (value && this.testataAperta) {
          await this.save()
        }
      },
      async refreshList(value) {
        if (value) {
          this.options.page = 1
          await this.getDataFromApi()
          this.$store.commit('lotti/CLEAR_REFRESH', 'testata')
        }
      },
      async filtraTipiLotto() {
        await this.getDataFromApi()
      }
    },
    /*     async created() {
      await this.getDefaultItem()
    }, */
    async mounted () {
      // await this.getDataFromApi()
/*       var numeroLotto = this.$route.query.num
      console.log('numeroLotto', numeroLotto) */
    },
    methods: {
      scadenzaLotto(item) {
        // prende la scadenza più vicina tra i prodotti presenti --> vedi readme
      },
/*       async nuovoDocumento() {
        prodotti.clearCache()
        _.set(this.locDocumento, 'tipoDocumento.codice', 'ordineCliente')
        this.nuovoDocumento = true
        this.forzaDocumento = 'ordineCliente'
        this.idDocumento = null
        this.showEditDocumento = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showEditDocumento = false
      }, */
      async onAcquisto() {
        this.nuovoDocumento = true
        this.idDocumento = null
        this.showLottoAcquisto = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showLottoAcquisto = false
      },
      async onAssemblaggio() {
        this.nuovoDocumento = true
        this.idDocumento = null
        this.showLottoAssemblaggio = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showLottoAssemblaggio = false
      },
      async onProduzione() {
        this.nuovoDocumento = true
        this.idDocumento = null
        this.showLottoProduzione = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showLottoProduzione = false
      },
      async onSezionamento() {
        this.nuovoDocumento = true
        this.idDocumento = null
        this.showLottoSezionamento = true
        await this.$nextTick()
        this.triggerUpdate++
        this.showLottoSezionamento = false
      },      
      async itemExpanded({ item, value }) {
        if (value) {
          // await this.aggiornaCollegato(item)
        }
      },      
/*       
      async aggiornaCollegato(item) {
        const collegato = await lotti.getLotto(item.trasforma.destinazione)
        this.lottoCollegato[item._id] = [collegato]
        this.triggerDettaglio++
      },
      destinazioni(item) {
        // in base al tipo lotto ed al suo stato, determino quali possono essere i lotti di destinazione
        const destinazioni = []
        switch (item.tipoLotto.tipoLotto) {
          case "ordineCliente":
            if (!item.stato || ['aperto', 'parziale'].includes(item.stato.codice)) {
              destinazioni.push({ codice: 'ddt', descrizione: 'Crea DDT cliente' })
              destinazioni.push({ codice: 'fatturaImmediata', descrizione: 'Crea Fattura Immediata cliente' })
              destinazioni.push({ codice: 'annullato', descrizione: 'Ordine annullato' })
            }
            break
          default:
            break
        }
        return destinazioni
      },      
      isFattura(item) {
        return item.tipoLotto.xml
      },
      async onCreazioniMultiple() {
        this.showDialogMultiple = true
        await this.$nextTick()
        this.showDialogMultiple = false
      }, */
      async getDefaultItem() {
        this.defaultItem = await documenti.getModello('lotto') // TODO: Gestire
        this.defaultItem.data = new Date()
      },
      async stampaLotto(item) {
        const result = await reporting.stampaLotto(this.$router, item, true, true)
        if (result.error) {
        }
      },
/*       async trasformaIn(destinazione, item) {
        const lotto = await lotti.getLotto(item._id)
        if (lotto) {
          if (destinazione.codice === 'annulalto') {
            lotto.stato = this.statoAnnullato
            await lotti.aggiornaLotto(lotto)
          } else {
            const elenco = await configurazioni.getConfigurazione('lotti_parametri', 'tipiLotto')
            const tipoDestinazione = elenco.find(x => x.codice === destinazione.codice)
            let newDoc = await lotti.trasformaLotto(lotto, tipoDestinazione, this.statoConvertito)
          }
          this.options.page = 1
          await this.getDataFromApi() 
        }
      }, */
/*       async generaXml(item) {
        const lotto = await lotti.getLotto(item._id)
        if (lotto) {
          const { fattura, nomeFile, xml7File } = await xml7.creaXml7Fattura(lotto)
          downloadXml(document, nomeFile, xml7File)
        }M230305-001
      },    */   
      async onRicerca(filtri) {
        console.log('filtri ricerca', filtri)
        this.filtri = filtri
        this.options.page = 1
        await this.getDataFromApi()
      },
      async getDataFromApi () {
        try {
          this.loading = true
          const filtri = { ...this.filtri }
          // TODO: Creare endpoint specifico per lotti ...
          filtri.tipoDocumento = (!filtri.tipoLotto || filtri.tipoLotto.length === 0) ? ['lottoAcquisto', 'lottoAssemblaggio', 'lottoProduzione', 'lottoSezionamento'] : filtri.tipoLotto
          const data = await documenti.getFilteredDocumentHeaders(filtri, this.options)
          this.lottiRaw = data && data.total_rows > 0 ? data.rows : []
          let docs = this.datiVisualizzazione(this.lottiRaw)
          if (this.filtroTipiLotto && this.filtroTipiLotto.length > 0) {
            docs = docs.filter(x => this.filtroTipiLotto.includes(x.tipoLotto.tipoLotto))
          }
          this.lotti = docs 
          this.totaleLotti = data.total_rows
        } catch(err) {
          this.lotti = []
          this.totaleLotti = 0
        } finally {
          this.loading = false
        }
      },
      async editItem (item, readonly) {
        this.idDocumento = item._id
        this.readOnly = readonly
        this.nuovoDocumento = false
        const tipo = capitalizeFirstLetter(item.tipoDocumento.codice)
        console.log(tipo)
        this['show' + tipo] = true

        // this.showEditLotto = true
        await this.$nextTick()
        this.triggerUpdate++
        this['show' + tipo] = false
      },      
      async completaAppoggio() {
        let itm = this.editedItem
        _.set(itm,'appoggio.clienteVisibile', itm.tipoLotto.visualizzaCliente)
        _.set(itm,'appoggio.fornitoreVisibile', itm.tipoLotto.visualizzaFornitore)
        _.set(itm,'appoggio.spedizioneVisibile', itm.tipoLotto.infoSpedizione)
        _.set(itm,'appoggio.pagamentoVisibile', itm.tipoLotto.infoPagamento)
        _.set(itm,'appoggio.tipoLotto', itm.tipoLotto)
        // const clienteId =  _.get(itm.anagrafica, 'cliente.codice', '') || _.get(itm.anagrafica, 'fornitore.codice', '')
        // const clifor = await clienti.getCliente(clienteId)
        const clifor = _.get(itm.anagrafica, 'cliente', '') || _.get(itm.anagrafica, 'fornitore', '')
        _.set(itm,'appoggio.clifor', clifor)
      },      
      close () {
        this.$store.commit('SET_RIGHT_DRAWER', false)
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async save () {
/*         this.$store.commit('lotti/CLEAR_DOCUMENTO_SAVED')
        this.editedItem = this.$store.getters['lotti/lotto']
        if (this.editedIndex > -1) {
          // verificare
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.editedItem.editInfo.utenteModifica = this.$store.getters.utente
          Object.assign(this.lotti[this.editedIndex], this.editedItem)
          if (!await lotti.aggiornaLotto(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        } else {
          const numeratore = this.editedItem.tipoLotto.numeratore
          this.editedItem = this.deleteDatiVisualizzazione(this.editedItem)
          this.editedItem.editInfo.utenteCreazione = this.$store.getters.utente
          // sarebbe meglio mettere il numeratore su lotti, ma finchè non c'è molecular fa troppi giri ....
          const annoRiferimento = getAnnoRiferimento(this.editedItem.data) // this.editedItem.data.getFullYear()
          const numero = await configurazioni.getNumeratore(numeratore, true, annoRiferimento)
          this.editedItem.codice = numero
          this.editedItem._id = numero
          this.lotti.push(this.editedItem)
          if (!await lotti.creaLotto(this.editedItem)) {
            this.dialogErrore = true
            return
          }
        }
        this.editedItem = null
        this.editedIndex = -1
        this.close()
        // va fatto il refresh della lista per prendere gli aggiornamenti
        await this.getDataFromApi() */
      },
      erroreConfirm() {
        this.dialogErrore = false
      },
      clickRow(item, options) {

      },
      dblclickRow(event, options) {
        const item = options.item
        this.editItem (item)
/*         this.editedIndex = this.lotti.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.$store.commit('lotti/SET_DOCUMENTO', this.editedItem)
        this.$store.commit('SET_RIGHT_DRAWER_READ_ONLY', true)
        this.$store.commit('SET_RIGHT_DRAWER', true) */
      },
      datiVisualizzazione(lotti) {
        const elaborati = lotti.map(el => {
         // const nominativo = (el.anagrafica.fornitore && el.anagrafica.fornitore.descrizione) || (el.anagrafica.cliente && el.anagrafica.cliente.descrizione)
          const nominativo = el.anagrafica && ((el.anagrafica.fornitore && el.anagrafica.fornitore.codice) || (el.anagrafica.cliente && el.anagrafica.cliente.codice)) || ''
          return { ...el, c_nominativo: nominativo }
        })
        return elaborati
      },
      deleteDatiVisualizzazione(lotto) {
        let locLotto = {...lotto}
        delete locLotto.c_nominativo
        delete locLotto.appoggio
        return locLotto
      },
      async onSpeedDialogComando(comando, payload) {
        switch (comando) {
          case 'stampa-etichette':
            const impostazioni = await configurazioni.getConfigurazione('display_generale', 'etichette')
/*             this.tipoStampa = impostazioni.tipo
            this.report = impostazioni.report
            this.isModuloA4 = impostazioni.tipo === 'pdf' */
            this.dialogStampa = true
            break
          default:
            break
        }
      },
      onDialogCancel() {
        this.dialogStampa = false
      },
      async onDialogPrint(usaQtaAnagrafica, salta, tipoStampa, report) {
        this.usaQtaAnagrafica = usaQtaAnagrafica
        // this.salta = salta
        this.dialogStampa = false
        const tipoQuantita = this.usaQtaAnagrafica ? 'anagrafica' : 'lotto'
        const lotti = this.selected
        for (let mm of lotti) {
          const filtriAggiuntivi = [{
            applicazione: 'lotti',
            chiave: 'riferimento.id',
            testo: mm.riferimento.id
          }]
          const parametri = {
            articoli: true,
            filtri: filtriAggiuntivi,
            gruppi: [],
            tipoQuantita
          }
          const filtro = {
            start: moment(mm.data).startOf('day').format('YYYYMMDD'),
            end: moment(mm.data).endOf('day').format('YYYYMMDD')
          }
          const filtroElementi = { filtro, parametri }
          const src = `${labelsPath}/${tipoStampa}/${report}?elm=${btoa(JSON.stringify(filtroElementi))}${salta ? '&sk=' + salta : ''}${tipoQuantita ? '&tpq=' + tipoQuantita : ''}`
          const printResult = await etichetteService.stampaDiretta(tipoStampa, src)
          if (printResult.status && printResult.status === 'error') {
            this.errorTitle = ' Errore stampa etichette'
            this.errorMessage = printResult.error
            this.dialogErrore = true
          }
        }
        this.annullaSelezione()
      },
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }

  td.td-lotto-selected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #1976d2 !important;
  }
</style>
